(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@mescius/inputman.richtexteditor"), require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["@mescius/inputman.richtexteditor", "react"], factory);
	else if(typeof exports === 'object')
		exports["InputManReact"] = factory(require("@mescius/inputman.richtexteditor"), require("react"));
	else
		root["InputManReact"] = factory(root["GC"], root["react"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__862__, __WEBPACK_EXTERNAL_MODULE__155__) => {
return 